import React from 'react'
import { productPropTypes } from 'Types'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { addFavourite, removeFavourite } from 'Actions'
import config, { gaSelectors } from 'Config'
import { Icon } from 'Blocks'
import { gaReady, gtagReady } from 'Utils'

const FavouriteButtonIcon = props => {
  const { product, className, favouritesUuids } = props
  const { uuid } = product
  const isFavourite = favouritesUuids.includes(uuid)
  const buttonGASettings = gaSelectors.getFavouriteBtnSettings

  function sendGAEvent(event, uuid, isFavourite) {
    if (gaReady()) {
      // eslint-disable-next-line no-undef
      ga('send', event)
      // eslint-disable-next-line no-undef
      ga(`${process.env.ANT_GA_CLIENT_TRACKER_NAME}.send`, event)
      // eslint-disable-next-line no-undef
    }

    if (gtagReady()) {
      // eslint-disable-next-line no-undef
        gtag(
          'event',
          event.eventAction,
          {
            tracker: `${process.env.ANT_GA_CLIENT_TRACKER_NAME}.send`,
            isFavourite: !isFavourite,
            productUuid: uuid,
            category: event.eventCategory,
          }
        )
    }

  }

  const eventLabelAction = isFavourite ? 'remove' : 'add'

  const gaEvent = {
    hitType: 'event',
    eventCategory: buttonGASettings.category,
    eventAction: buttonGASettings.action,
    eventLabel: `${eventLabelAction}-product=${uuid}`
  }

  function handleClick(e) {
    e.preventDefault()
    if (isFavourite) {
      props.removeFavourite(uuid)
    } else {
      props.addFavourite(product)
    }
    sendGAEvent(gaEvent, uuid, isFavourite)
  }

  if (!config.favouritesEnabled) return null

  const iconName = isFavourite ? 'favorite' : 'favorite_border'
  return (
    <button
      onClick={e => handleClick(e)}
      className={`${className} favourite-button`}
    >
      <Icon className="favourite-button__icon" name={iconName} />
    </button>
  )
}

FavouriteButtonIcon.propTypes = {
  product: PropTypes.shape(productPropTypes),
  className: PropTypes.string,
  favouritesUuids: PropTypes.array,
  removeFavourite: PropTypes.func,
  addFavourite: PropTypes.func
}

const mapStateToProps = state => ({
  favouritesUuids: state.UI.favourites.uuids
})

const mapDispatchToProps = dispatch => {
  return {
    addFavourite: bindActionCreators(addFavourite, dispatch),
    removeFavourite: bindActionCreators(removeFavourite, dispatch),
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FavouriteButtonIcon)
